const categories = [
  { label: 'italian', id: 'italian_category' },
  { label: 'spanish', id: 'spanish_category' },
  { label: 'american', id: 'american_category' },
  { label: 'french', id: 'french_category' },
  { label: 'malay', id: 'malay_category' },
  { label: 'chinese', id: 'chinese_category' },
  { label: 'indian', id: 'indian_category' },
  { label: 'thai', id: 'thai_category' },
  { label: 'korean', id: 'korean_category' },
  { label: 'japanese', id: 'japanese_category' },
  { label: 'vietnamese', id: 'vietnamese_category' },
  { label: 'german', id: 'german_category' },
  { label: 'brazilian', id: 'brazilian_category' },
  { label: 'egyptian', id: 'eygptian_category' },
  { label: 'greek', id: 'greek_category' },
  { label: 'turkish', id: 'turkish_category' },
  { label: 'mexican', id: 'mexican_category' },
  { label: 'russian', id: 'russian_category' },
  { label: 'jewish', id: 'jewish_category' },
  { label: 'portuguese', id: 'portuguese_category' },
];

export default categories;
